import { Button, Col, Collapse, Divider, Form, Icon, Input, Modal, Popover, Row } from 'antd'
import React, { Component } from 'react'
import { getStringFormula, getUnityFormule, stringFormulas } from '../../../../utils/unity'
import { findWhere } from '../../../../utils/db_functions'
import '../component-kit.css'
import { getValuesToConsumption } from '../../shared/component-mounting-instalation-functions'
import ButtonGroup from 'antd/lib/button/button-group'
import InputCompositionModal from './input-composition-modal'
import { getMaterialCost, getTotalCost } from '../../../supplies/inputs/inputs'

export default class InputCompositionTable extends Component {

    constructor(props) {
        super(props)
        this.state = {
            inputGroups: this.props.inputGroups,
            inputs: [],

            addInputModal: false,
            updateInputModal: false,
            form: {},
            unitySelectArray: [],
            inputIndexToUpdate: null,
        }
    }

    componentDidMount = async () => {
        const inputs = await this.getInputs((this.props.inputGroups || []).map(inputGroup => inputGroup.rows).flat().map(el => el.specification).filter(el => el))

        const unitySelectArray = await findWhere('Config', 'name', ['unidades'])

        this.setState({ inputGroups: this.props.inputGroups, inputs, unitySelectArray: unitySelectArray[0].get('value') })
    }

    componentWillReceiveProps = async (nextProps) => {
        if (nextProps.inputGroups !== this.state.inputGroups) {
            const inputs = await this.getInputs((nextProps.inputGroups || []).map(inputGroup => inputGroup.rows).flat().map(el => el.specification).filter(el => el))
            this.setState({ inputGroups: nextProps.inputGroups, inputs })
        }
    }

    getInputs = async (inputIds) => {
        const inputs = await findWhere('Input', 'objectId', inputIds)
        return inputs
    }

    getInputById = (inputId) => {
        return this.state.inputs.find(input => input.id === inputId)
    }

    renderInput = (inputParseObject, input, inputGroupIndex, inputIndex) => {

        const inputDataLabelAndValue = [
            { label: 'Unidade', value: 'unity' },
            { label: 'Qtd', value: 'amount_component' },
            { label: 'Largura', value: 'width_component' },
            { label: 'Espessura', value: 'thickness_component' },
            { label: 'Comprimento', value: 'length_component' },
        ]

        let consumer = 0
        let finalValue = 0
        let convert = 0
        if (inputParseObject) {
            let r = getUnityFormule((inputParseObject.get('measure')), input.unity, this.props.convertionFormulas)(getValuesToConsumption(input, inputParseObject.toJSON()))
            consumer = (r === Infinity) ? 0 : r;
            finalValue = this.props.calculateUnitCost(inputParseObject.toJSON(), input)
            convert = inputParseObject.get('convert')
        }

        return (
            <Row gutter={24}>
                <Col span={20}>
                    <Row gutter={24}>
                        <div className='inputCompositionInputTitle'>
                            {inputParseObject && inputParseObject.get('material_description')}
                        </div>
                    </Row>
                    <Row gutter={24}>
                        {
                            inputDataLabelAndValue.map(labelAndValue => {
                                return (
                                    <Col span={3}>
                                        <div className='inputCompositionInputSubtitle'>
                                            {labelAndValue.label}
                                        </div>
                                        <div className='inputCompositionInputSubSubtitle'>
                                            {input[labelAndValue.value]}
                                        </div>
                                    </Col>
                                )
                            })
                        }
                        <Col span={3}>
                            <div className='inputCompositionInputSubtitle'>
                                Conversão
                            </div>
                            <div className='inputCompositionInputSubSubtitle'>
                                {(convert || 0).toFixed(2)}
                            </div>
                        </Col>

                        <Col span={3}>
                            <div className='inputCompositionInputSubtitle'>
                                Consumo
                            </div>
                            <div className='inputCompositionInputSubSubtitle'>
                                {(consumer || 0).toFixed(4)}
                            </div>
                        </Col>

                        <Col span={3}>
                            <div className='inputCompositionInputSubtitle'>
                                Total
                            </div>
                            <div className='inputCompositionInputSubSubtitle'>
                                {(finalValue || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                            </div>
                        </Col>
                    </Row>
                </Col>

                <Col span={4}>
                    <div className='inputCompositionInputActionButtons'>
                        <ButtonGroup>
                            <Popover content='Informações detalhadas do insumo'>
                                <Button
                                    icon="info-circle"
                                    onClick={() => {
                                        if (inputParseObject) {
                                            const data = inputParseObject.toJSON()

                                            const formula = getStringFormula(this.props.convertionFormulas, data.measure, data.consumption_measure)
                                            const formulaToGetName = this.props.convertionFormulas.find(el => el.get('formula') === formula)

                                            Modal.info({
                                                width: '50%',
                                                title: <div><h2>Detalhes do insumo - Cod. {data.code}</h2></div>,
                                                className: 'remove-margin',
                                                content: (
                                                    <div>
                                                        <Divider />
                                                        <p>Descrição: <b>{data.material_description}</b></p>
                                                        <p>Fornecedor: <b>{data.provider}</b></p>
                                                        <Divider />
                                                        <p>Unidade Compra: <b>{data.measure}</b></p>
                                                        <p>Unidade Consumo: <b>{data.consumption_measure}</b></p>
                                                        <p>Conversão: <b>{data.convert || 0}</b></p>
                                                        <p>
                                                            Fórmula de conversão:
                                                            <Popover content={formula ? stringFormulas[formula] : 'Sem fórmula padrão'}>
                                                                <b>{formulaToGetName ? `${formulaToGetName.get('name')}` : ''}</b>
                                                            </Popover>
                                                        </p>
                                                        <Divider />
                                                        <p>Custo de aquisição: <b>{getMaterialCost(data).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</b></p>
                                                        <p>Preço final: <b>{getTotalCost(data).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</b></p>
                                                        <Divider />
                                                    </div >
                                                )
                                            })
                                        }
                                    }}
                                />
                            </Popover>

                            <Popover content='Editar insumo'>
                                <Button
                                    icon='edit'
                                    onClick={() => {
                                        this.setState({
                                            inputIndexToUpdate: `${inputGroupIndex}_${inputIndex}`,
                                            updateInputModal: true,
                                            form: { ...input }
                                        })
                                    }}
                                />
                            </Popover>

                            <Popover content='Deletar insumo'>
                                <Button
                                    icon='delete'
                                    onClick={() => {
                                        let _this = this
                                        Modal.confirm({
                                            iconType: 'exclamation-circle',
                                            title: 'Tem certeza que deseja excluir esse insumo?',
                                            content: 'Essa ação não poderá ser desfeita',
                                            onOk() {
                                                let inputGroups = _this.state.inputGroups
                                                inputGroups[inputGroupIndex].rows.splice(inputIndex, 1)
                                                _this.props.updateDescriptions(inputGroups)
                                            },
                                            okText: 'Sim',
                                            cancelText: 'Não, deixa pra lá'
                                        })
                                    }}
                                />
                            </Popover>
                        </ButtonGroup>
                    </div>
                </Col>
                <Divider />
            </Row>
        )
    }

    render() {

        return (
            <div>
                <Collapse>
                    {(this.state.inputGroups || []).map((inputGroup, inputGroupIndex) => {
                        return (
                            <Collapse.Panel
                                header={
                                    <div>
                                        <div className='inputCompositionInputGroupTitle'>
                                            {inputGroup.description}
                                            &#160; &#160; &#160; &#160;

                                            <Popover content='Editar grupo'>
                                                <Icon
                                                    type='edit'
                                                    onClick={() => {
                                                        let inputGroupName = inputGroup.description
                                                        const _this = this
                                                        Modal.confirm({
                                                            iconType: 'edit',
                                                            title: 'Composição',
                                                            content: (
                                                                <div>
                                                                    <Form.Item label='Nome da composição'>
                                                                        <Input
                                                                            placeholder='Informe o nome da composição'
                                                                            defaultValue={inputGroup.description}
                                                                            onChange={e => {
                                                                                inputGroupName = e.target.value
                                                                            }}
                                                                        />
                                                                    </Form.Item>
                                                                </div>
                                                            ),
                                                            okText: 'Salvar',
                                                            cancelText: 'Cancelar',
                                                            onOk: () => {
                                                                let inputGroups = _this.state.inputGroups
                                                                inputGroups[inputGroupIndex].description = inputGroupName
                                                                _this.props.updateDescriptions(inputGroups)
                                                            }
                                                        })
                                                    }}
                                                />
                                            </Popover>
                                            &#160; &#160; &#160; &#160;

                                            <Popover content='Copiar'>
                                                <Icon
                                                    type='copy'
                                                    onClick={() => {
                                                        let inputGroup = null
                                                        const _this = this
                                                        Modal.confirm({
                                                            iconType: 'copy',
                                                            title: 'Duplicar',
                                                            content: (
                                                                <div>
                                                                    <Form.Item label='Nome da composição'>
                                                                        <Input
                                                                            onChange={e => inputGroup = e.target.value}
                                                                            style={{ width: '100%' }}
                                                                            placeholder='Nome da composição'
                                                                        />
                                                                    </Form.Item>
                                                                </div>
                                                            ),
                                                            okText: 'Salvar',
                                                            cancelText: 'Cancelar',
                                                            onOk: () => {
                                                                let inputGroups = _this.state.inputGroups
                                                                inputGroups.push({
                                                                    description: inputGroup,
                                                                    rows: [..._this.state.inputGroups[inputGroupIndex].rows]
                                                                })
                                                                _this.props.updateDescriptions(inputGroups)
                                                            }
                                                        })

                                                    }}
                                                />
                                            </Popover>
                                            &#160; &#160; &#160; &#160;

                                            <Popover content='Deletar'>
                                                <Icon
                                                    type='delete'
                                                    onClick={() => {
                                                        let _this = this
                                                        Modal.confirm({
                                                            iconType: 'exclamation-circle',
                                                            title: 'Tem certeza que deseja excluir esse grupo?',
                                                            content: 'Essa ação não poderá ser desfeita',
                                                            onOk() {
                                                                let inputGroups = _this.state.inputGroups
                                                                inputGroups.splice(inputGroupIndex, 1)
                                                                _this.props.updateDescriptions(inputGroups)
                                                            },
                                                            okText: 'Sim',
                                                            cancelText: 'Não, deixa pra lá'
                                                        })
                                                    }}
                                                />
                                            </Popover>
                                        </div>
                                        <div className='inputCompositionInputGroupSubtitle'>
                                            Preço Total da composição: {this.props.calculateSubTotalCost(inputGroup.rows, this.state.inputs)}
                                        </div>
                                    </div>
                                }
                                key={inputGroupIndex}
                            >
                                {
                                    (inputGroup.rows || []).map((input, inputIndex) => {
                                        const inputObject = this.getInputById(input.specification)

                                        return <div key={`${inputGroupIndex}_${inputIndex}`}>{this.renderInput(inputObject, input, inputGroupIndex, inputIndex)}</div>
                                    })
                                }
                                <Button
                                    icon='plus'
                                    type='primary'
                                    style={{ marginTop: '10px' }}
                                    onClick={() => this.setState({ addInputModal: true, inputIndexToUpdate: `${inputGroupIndex}_0`, })}
                                >
                                    Adicionar insumo
                                </Button>
                            </Collapse.Panel>
                        )
                    })}
                </Collapse>

                <Button
                    icon='plus'
                    style={{ marginTop: '10px' }}
                    onClick={() => {
                        let inputGroupName = null
                        const _this = this
                        Modal.confirm({
                            iconType: 'edit',
                            title: 'Composição',
                            content: (
                                <div>
                                    <Form.Item label='Nome da composição'>
                                        <Input
                                            placeholder='Informe o nome da composição'
                                            defaultValue={inputGroupName}
                                            onChange={e => {
                                                inputGroupName = e.target.value
                                            }}
                                        />
                                    </Form.Item>
                                </div>
                            ),
                            okText: 'Adicionar',
                            cancelText: 'Cancelar',
                            onOk: () => {
                                let inputGroups = _this.state.inputGroups || []
                                inputGroups.push({
                                    description: inputGroupName,
                                    rows: []
                                })
                                _this.props.updateDescriptions(inputGroups)
                            }
                        })
                    }}
                >
                    Adicionar composição
                </Button>

                <InputCompositionModal
                    modalVisible={this.state.addInputModal}
                    closeModal={() => {
                        this.setState({
                            addInputModal: false,
                            form: {},
                            inputIndexToUpdate: null,
                        })
                    }}
                    form={this.state.form}
                    unitySelectArray={this.state.unitySelectArray}
                    addUpdateInput={async inputToAdd => {

                        const inputAlreadInInputArray = this.getInputById(inputToAdd.specification)
                        if (!inputAlreadInInputArray && inputToAdd.specification) {
                            const inputs = await this.getInputs([...this.state.inputs.map(input => input.id), inputToAdd.specification])
                            this.setState({ inputs })
                        }

                        let inputGroups = this.state.inputGroups
                        inputGroups[parseInt(this.state.inputIndexToUpdate.split('_')[0])].rows.push(inputToAdd)
                        this.props.updateDescriptions(inputGroups)
                    }}
                />

                <InputCompositionModal
                    modalVisible={this.state.updateInputModal}
                    closeModal={() => {
                        this.setState({
                            updateInputModal: false,
                            form: {},
                            inputIndexToUpdate: null,
                        })
                    }}
                    form={this.state.form}
                    unitySelectArray={this.state.unitySelectArray}
                    addUpdateInput={async inputToUpdate => {

                        const inputAlreadInInputArray = this.getInputById(inputToUpdate.specification)
                        if (!inputAlreadInInputArray && inputToUpdate.specification) {
                            const inputs = await this.getInputs([...this.state.inputs.map(input => input.id), inputToUpdate.specification])
                            this.setState({ inputs })
                        }

                        let inputGroups = this.state.inputGroups
                        inputGroups[parseInt(this.state.inputIndexToUpdate.split('_')[0])].rows[parseInt(this.state.inputIndexToUpdate.split('_')[1])] = inputToUpdate
                        this.props.updateDescriptions(inputGroups)
                    }}
                />
            </div>
        )
    }

}